import React from 'react';
import {
  FEATURED_GRADIENTS,
  formatCurrency,
  getCreatorName,
  getFundingGoalDisplay,
  getFundingProgress,
  getProjectTitle,
} from '../fundingUtils';

export default function FundingFeatured({ ideas, fundedIds, onFund }) {
  const featured = ideas.slice(0, 6);
  if (featured.length === 0) return null;

  return (
    <section className="funding-featured" id="featured-projects" aria-labelledby="featured-heading">
      <div className="funding-section-head">
        <h2 id="featured-heading">Featured Projects</h2>
        <p>Hand-picked ventures seeking backers and collaborators.</p>
      </div>
      <div className="funding-featured-track">
        {featured.map((idea, index) => {
          const progress = getFundingProgress(idea, fundedIds);
          const goal = getFundingGoalDisplay(idea);
          const raised = Math.round((goal * progress) / 100);
          const isFunded = fundedIds.includes(idea._id);
          const gradient = FEATURED_GRADIENTS[index % FEATURED_GRADIENTS.length];

          return (
            <article key={idea._id || index} className="funding-featured-card">
              <div
                className="funding-featured-thumb"
                style={{ background: gradient }}
                aria-hidden
              >
                <span className="funding-featured-thumb-icon">✦</span>
              </div>
              <div className="funding-featured-body">
                <h3>{getProjectTitle(idea, index)}</h3>
                <p className="funding-featured-creator">{getCreatorName(idea)}</p>
                <div className="funding-progress-wrap">
                  <div className="funding-progress-meta">
                    <span>{formatCurrency(raised)} raised</span>
                    <span>{progress}%</span>
                  </div>
                  <div className="funding-progress-bar" role="progressbar" aria-valuenow={progress} aria-valuemin={0} aria-valuemax={100}>
                    <div className="funding-progress-fill" style={{ width: `${progress}%` }} />
                  </div>
                </div>
                <button
                  type="button"
                  className={`funding-featured-fund ${isFunded ? 'funding-featured-fund--done' : ''}`}
                  disabled={isFunded}
                  onClick={() => onFund(idea)}
                >
                  {isFunded ? 'Funded' : 'Fund the project'}
                </button>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
